<script setup lang="ts">
import {
    nextTick, ref, unref, watch,
} from 'vue';

const props = defineProps<{
    target: string;
    disabled?: boolean;
    redraw?: number;
}>();
//doens't work without selector
const DEFAULT_SELECTOR = '#portal-target';
const portalSelector = ref(DEFAULT_SELECTOR);
const portalDisabled = ref(true);

type Transition = () => Promise<unknown>;
const transitions: Transition[] = [];
let prev = { ...props };

function processTransitions() {
    const transition = transitions[0];
    if(!transition) {
        return;
    }
    transition().then(() => {
        transitions.shift();
        processTransitions();
    });
}

watch(props, (val) => {
    const haveTrasitions = transitions.length && transitions[0];
    const cur = { ...val };
    const waitPortalTransition = () => new Promise((resolve) => {
        nextTick(() => {
            nextTick(() => {
                resolve(undefined);
            });
        });
    });
    const disablePortal = (disabled: boolean) => (() => {
        const _portalDisabled = disabled;
        const _portalSelector = disabled ? DEFAULT_SELECTOR : cur.target;
        if((unref(portalSelector) === _portalSelector) && (unref(portalDisabled) === _portalDisabled)) {
            return Promise.resolve(undefined);
        }
        portalDisabled.value = _portalDisabled;
        portalSelector.value = _portalSelector;
        return waitPortalTransition();
    });

    if(cur.disabled) {
        transitions.push(disablePortal(true));
    } else if((cur.target !== prev.target) || (cur.redraw !== prev.redraw)) {
        //switch to take effect
        transitions.push(disablePortal(true));
        transitions.push(disablePortal(false));
    } else {
        transitions.push(disablePortal(false));
    }
    prev = cur;
    if(!haveTrasitions) {
        processTransitions();
    }
});
</script>

<template>
    <div :v-show="undefined">
        <Teleport :to="portalSelector" :disabled="portalDisabled">
            <slot />
        </Teleport>
        <slot name="context" />
    </div>
</template>
